import { StyleSheet, Dimensions } from "react-native";
import { FlickOColors } from "./color";
import { getResponsiveSize } from "./globalStyles";

const { width } = Dimensions.get("window");

export const registrationStyles = StyleSheet.create({
  exploreSection: {
    marginVertical: getResponsiveSize(16),
    paddingHorizontal: getResponsiveSize(16),
  },
  exploreTitle: {
    fontSize: getResponsiveSize(24),
    fontWeight: "600",
    color: FlickOColors.text.primary,
    marginBottom: getResponsiveSize(4),
  },
  exploreSubtitle: {
    fontSize: getResponsiveSize(16),
    color: FlickOColors.text.secondary,
    fontWeight: "500",
    letterSpacing: 0.5,
  },
  noDataContainer: {
    padding: getResponsiveSize(20),
    alignItems: "center",
    justifyContent: "center",
  },
  noDataMessage: {
    color: FlickOColors.gray.dark,
    textAlign: "center",
    fontSize: getResponsiveSize(14),
  },
  errorText: {
    color: "#FF3B30",
    fontSize: getResponsiveSize(12),
    marginLeft: getResponsiveSize(4),
    marginBottom: getResponsiveSize(8),
    fontWeight: "400",
  },
  labelText: {
    fontSize: width > 768 ? getResponsiveSize(14) : getResponsiveSize(12),
    color: FlickOColors.gray.dark2,
    fontWeight: "500",
    marginLeft: 3,
  },
  coordinatesToggle: {
    flexDirection: "row",
    alignItems: "center",
    gap: getResponsiveSize(8),
    marginTop: getResponsiveSize(12),
  },
  coordinatesContainer: {
    padding: getResponsiveSize(16),
    flexDirection: "row",
    gap: getResponsiveSize(16),
  },
  coordinateInput: {
    flex: 1,
    textAlign: "center",
    width: "40%",
  },
  toggleContainer: {
    flexDirection: "row",
    alignItems: "center",
    gap: getResponsiveSize(8),
  },

  toggleLabel: {
    fontSize: getResponsiveSize(14),
    color: FlickOColors.text.primary,
  },
  infoIconContainer: {
    marginLeft: getResponsiveSize(4),
  },

  infoIcon: {
    fontSize: getResponsiveSize(14),
    color: FlickOColors.text.secondary,
  },

  tooltip: {
    position: "absolute",
    backgroundColor: "#1F2937",
    padding: getResponsiveSize(8),
    borderRadius: 4,
    alignSelf: "flex-start", // Key change: allows width to match content
    zIndex: 1000,
    width: getResponsiveSize(2400),
    left: getResponsiveSize(24),
    top: -getResponsiveSize(4),
  },

  tooltipText: {
    color: FlickOColors.white,
    fontSize: getResponsiveSize(12),
    flexWrap: "wrap",
  },

  labelContainer: {
    flexDirection: "row",
    alignItems: "center",
  },

  // Image styles
  imageSection: {
    marginBottom: getResponsiveSize(16),
    position: "relative",
  },

  itemImage: {
    width: getResponsiveSize(160),
    height: getResponsiveSize(160),
    borderRadius: 8,
    borderWidth: 1,
    borderColor: FlickOColors.gray.lighter,
    backgroundColor: FlickOColors.white,
  },

  // Food Type styles
  foodTypeButtons: {
    flexDirection: "row",
    gap: getResponsiveSize(16),
  },

  foodTypeButton: {
    flexDirection: "row",
    alignItems: "center",
    gap: getResponsiveSize(8),
    padding: getResponsiveSize(8),
    borderRadius: getResponsiveSize(6),
    borderWidth: 1,
    borderColor: FlickOColors.gray.light,
  },

  selectedFoodType: {
    backgroundColor: FlickOColors.primary + "10",
    borderColor: FlickOColors.primary,
  },

  foodTypeIcon: {
    width: getResponsiveSize(20),
    height: getResponsiveSize(20),
    borderRadius: 4,
    borderWidth: 1,
    justifyContent: "center",
    alignItems: "center",
  },

  vegIcon: {
    borderColor: "#00A877",
  },
  nonVegIcon: {
    borderColor: "#FF0000",
  },
  eggIcon: {
    borderColor: "#FFB52E",
  },
  innerDot: {
    width: getResponsiveSize(12),
    height: getResponsiveSize(12),
    borderRadius: 6,
  },
  eggText: {
    fontSize: getResponsiveSize(12),
  },

  foodTypeText: {
    fontSize: getResponsiveSize(14),
  },

  taxSymbol: {
    fontSize: getResponsiveSize(16),
    color: FlickOColors.text.primary,
  },

  // Checkbox styles
  checkboxGroup: {
    flexDirection: "row",
    gap: getResponsiveSize(16),
  },

  checked: {
    backgroundColor: FlickOColors.primary,
    borderColor: FlickOColors.primary,
  },
  updateModalContent: {
    backgroundColor: FlickOColors.white,
    width: "100%", // Takes full width
    minHeight: "100%", // Takes full height
    paddingHorizontal: getResponsiveSize(20),
    paddingVertical: getResponsiveSize(24),
    flex: 1, // Added to ensure content can grow
  },
  modalScroll: {
    flex: 1,
    width: "100%",
  },
  inputLabel: {
    fontSize: getResponsiveSize(14),
    fontWeight: "500",
    marginBottom: getResponsiveSize(8),
    color: FlickOColors.text.primary,
  },

  textArea: {
    minHeight: getResponsiveSize(120), // Increased for 3 lines + padding
    height: "auto", // Allow dynamic height
    textAlignVertical: "top",
    paddingTop: getResponsiveSize(12), // Add top padding for text alignment
    paddingBottom: getResponsiveSize(12), // Add bottom padding
  },

  modalFooter: {
    flexDirection: "row",
    justifyContent: "flex-end",
    gap: getResponsiveSize(12),
    paddingTop: getResponsiveSize(16),
    borderTopWidth: 1,
    borderTopColor: FlickOColors.gray.light,
  },

  saveButton: {
    backgroundColor: FlickOColors.primary,
    paddingVertical: getResponsiveSize(12),
    paddingHorizontal: getResponsiveSize(24),
    borderRadius: 8,
  },

  saveButtonText: {
    color: FlickOColors.white,
    fontSize: getResponsiveSize(14),
    fontWeight: "500",
  },

  discardButton: {
    backgroundColor: FlickOColors.white,
    paddingVertical: getResponsiveSize(12),
    paddingHorizontal: getResponsiveSize(24),
    borderRadius: 8,
    borderWidth: 1,
    borderColor: FlickOColors.gray.light,
  },

  discardButtonText: {
    color: FlickOColors.text.primary,
    fontSize: getResponsiveSize(14),
    fontWeight: "500",
  },

  addOptionsContainer: {
    position: "relative",
    flexDirection: "row",
    marginBottom: getResponsiveSize(16),
    zIndex: 1000,
  },

  addButton: {
    backgroundColor: FlickOColors.primary,
    paddingHorizontal: getResponsiveSize(16),
    paddingVertical: getResponsiveSize(8),
    borderRadius: 6,
  },

  addButtonText: {
    color: FlickOColors.white,
    fontSize: getResponsiveSize(14),
    fontWeight: "500",
  },
  dropdownText: {
    fontSize: getResponsiveSize(14),
    color: FlickOColors.text.primary,
    padding: getResponsiveSize(8),
  },
  dropdownMenu: {
    position: "absolute",
    top: "100%",
    right: 0,
    backgroundColor: FlickOColors.white,
    borderRadius: 6,
    borderWidth: 1,
    borderColor: FlickOColors.gray.light,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.1,
    shadowRadius: 3,
    elevation: 3,
    zIndex: 999,
  },

  dropdownItem: {
    padding: getResponsiveSize(12),
    borderBottomWidth: 1,
    borderBottomColor: FlickOColors.gray.light,
  },

  menuItemRow: {
    flexDirection: "row",
    alignItems: "center",
    padding: getResponsiveSize(12),
    borderBottomWidth: 1,
    borderBottomColor: FlickOColors.gray.light,
  },

  itemName: {
    flex: 2,
    fontSize: getResponsiveSize(14),
  },

  itemPrice: {
    flex: 1,
    fontSize: getResponsiveSize(14),
  },

  toggleButton: {
    paddingHorizontal: getResponsiveSize(12),
    paddingVertical: getResponsiveSize(6),
    borderRadius: 4,
    backgroundColor: FlickOColors.gray.light,
    marginRight: getResponsiveSize(12),
  },

  toggleEnabled: {
    backgroundColor: FlickOColors.green,
  },

  toggleText: {
    fontSize: getResponsiveSize(12),
    color: FlickOColors.white,
  },

  actionButton: {
    padding: getResponsiveSize(8),
  },

  modalOverlay: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    justifyContent: "center",
    alignItems: "center",
  },

  modalCloseButton: {
    alignSelf: "flex-end",
    padding: getResponsiveSize(8),
  },
  subCategoryContainer: {
    marginTop: getResponsiveSize(12),
    padding: getResponsiveSize(12),
    backgroundColor: FlickOColors.gray.lighter,
    borderRadius: 8,
  },

  subCategoryTitle: {
    fontSize: getResponsiveSize(14),
    fontWeight: "500",
    marginBottom: getResponsiveSize(8),
  },

  menuItemHeader: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: getResponsiveSize(8),
  },

  menuItemType: {
    fontSize: getResponsiveSize(12),
    padding: getResponsiveSize(4),
    paddingHorizontal: getResponsiveSize(8),
    backgroundColor: FlickOColors.green,
    borderRadius: 4,
  },

  serviceTypeButton: {
    padding: getResponsiveSize(4),
    paddingHorizontal: getResponsiveSize(8),
    borderRadius: 4,
    borderWidth: 1,
    borderColor: FlickOColors.gray.light,
  },

  activeServiceType: {
    backgroundColor: FlickOColors.primary,
    borderColor: FlickOColors.primary,
  },

  descriptionInput: {
    minHeight: getResponsiveSize(80),
    textAlignVertical: "top",
  },

  priceContainer: {
    flexDirection: "row",
    gap: getResponsiveSize(8),
  },

  priceInput: {
    flex: 2,
  },
  acceptButtonText: {
    color: FlickOColors.white,
    fontSize: getResponsiveSize(16),
    fontWeight: "500",
  },
  cancelButtonText: {
    color: FlickOColors.primary,
    fontSize: getResponsiveSize(16),
    fontWeight: "500",
  },
  submitButtonText: {
    // Add this if missing
    color: FlickOColors.white,
    fontSize: getResponsiveSize(16),
    fontWeight: "500",
  },
  modalContainer: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "rgba(0, 0, 0, 0.5)", // Semi-transparent background
  },
  modalContent: {
    // New style
    backgroundColor: FlickOColors.white,
    width: width > 768 ? "60%" : "90%",
    height: width > 768 ? "60%" : "80%",
    borderRadius: width > 768 ? 12 : 8,
    padding: width > 768 ? getResponsiveSize(20) : getResponsiveSize(16),
  },
  modalTitle: {
    fontSize: getResponsiveSize(20),
    fontWeight: "600",
    marginBottom: getResponsiveSize(16),
  },
  termsScroll: {
    flex: 1,
    marginBottom: getResponsiveSize(16),
  },
  termsContent: {
    fontSize: getResponsiveSize(7),
    color: FlickOColors.gray.dark2,
  },
  modalButtons: {
    flexDirection: "row",
    gap: getResponsiveSize(12),
  },
  acceptButton: {
    flex: 1,
    backgroundColor: FlickOColors.primary,
    padding: getResponsiveSize(12),
    borderRadius: 8,
    alignItems: "center",
  },
  cancelButton: {
    flex: 1,
    borderWidth: 1,
    borderColor: FlickOColors.primary,
    padding: getResponsiveSize(12),
    borderRadius: 8,
    alignItems: "center",
  },
  submitButton: {
    backgroundColor: FlickOColors.primary,
    padding: getResponsiveSize(12),
    borderRadius: 8,
    alignItems: "center",
  },
  disabledButton: {
    opacity: 0.5,
  },
  termsLink: {
    color: FlickOColors.primary,
    textDecorationLine: "underline",
  },
  inputGroup: {
    marginBottom: getResponsiveSize(20),
  },
  label: {
    fontSize: getResponsiveSize(14),
    fontWeight: "500",
    marginBottom: getResponsiveSize(8),
  },
  dateInput: {
    flexDirection: "row",
    alignItems: "center",
    gap: getResponsiveSize(8),
    position: "relative",
  },
  uploadSection: {
    marginTop: getResponsiveSize(20),
  },
  gstOptions: {
    gap: getResponsiveSize(12),
    marginBottom: getResponsiveSize(24),
  },
  gstOption: {
    padding: getResponsiveSize(16),
    borderRadius: 8,
    borderWidth: 1,
    borderColor: FlickOColors.gray.light,
  },
  gstForm: {
    marginTop: getResponsiveSize(20),
  },
  taxInput: {
    flexDirection: "row",
    alignItems: "center",
    gap: getResponsiveSize(8),
  },
  percentageSymbol: {
    fontSize: getResponsiveSize(16),
    color: FlickOColors.text.primary,
  },
  taxInfo: {
    fontSize: getResponsiveSize(12),
    color: FlickOColors.text.secondary,
    marginTop: getResponsiveSize(4),
  },
  packagingOptions: {
    gap: getResponsiveSize(12),
    marginBottom: getResponsiveSize(24),
  },
  packagingOption: {
    padding: getResponsiveSize(16),
    borderRadius: 8,
    borderWidth: 1,
    borderColor: FlickOColors.gray.light,
  },
  selectedOption: {
    borderColor: FlickOColors.primary,
    backgroundColor: FlickOColors.primary + "10",
  },
  optionText: {
    fontSize: getResponsiveSize(14),
    color: FlickOColors.text.primary,
  },
  selectedOptionText: {
    color: FlickOColors.primary,
    fontWeight: "500",
  },
  fixedChargeInput: {
    marginTop: getResponsiveSize(8),
    marginLeft: getResponsiveSize(16),
    width: getResponsiveSize(200),
  },
  rangeTable: {
    borderWidth: 1,
    borderColor: FlickOColors.gray.light,
    borderRadius: 8,
    overflow: "hidden",
  },
  tableHeader: {
    flexDirection: "row",
    backgroundColor: FlickOColors.gray.lighter,
    padding: getResponsiveSize(12),
    gap: getResponsiveSize(12), // Match gap in rows
  },
  tableHeaderText: {
    fontWeight: "500",
    color: FlickOColors.text.primary,
  },
  tableRow: {
    flexDirection: "row",
    borderTopWidth: 1,
    borderTopColor: FlickOColors.gray.light,
    padding: getResponsiveSize(12),
    gap: getResponsiveSize(12), // Add gap between cells
  },
  tableCell: {
    width: "25%", // Each column takes 25% of table width
    paddingHorizontal: getResponsiveSize(4),
  },
  tableInput: {
    padding: getResponsiveSize(8),
    borderWidth: 1,
    borderColor: FlickOColors.gray.light,
    borderRadius: 4,
  },
  deleteButton: {
    width: "10%", // Smaller delete column
    alignItems: "center",
    justifyContent: "center",
  },
  addRangeButton: {
    padding: getResponsiveSize(12),
    alignItems: "center",
    borderTopWidth: 1,
    borderTopColor: FlickOColors.gray.light,
  },
  addRangeText: {
    color: FlickOColors.primary,
    fontSize: getResponsiveSize(14),
  },
  dayText: {
    fontSize: getResponsiveSize(14),
    color: FlickOColors.text.primary,
    minWidth: "9ch",
  },
  uploadInfoText: {
    fontSize: getResponsiveSize(14),
    color: FlickOColors.text.secondary,
  },
  menuContainer: {
    gap: getResponsiveSize(24),
  },

  cardHeader: {
    flexDirection: "row",
    alignItems: "center",
    gap: getResponsiveSize(12),
    marginBottom: getResponsiveSize(16),
  },
  cardTitle: {
    fontSize: getResponsiveSize(18),
    fontWeight: "600",
    color: FlickOColors.text.primary,
  },
  subtitle: {
    fontSize: getResponsiveSize(14),
    color: FlickOColors.text.secondary,
    marginBottom: getResponsiveSize(16),
  },
  uploadInfo: {
    flexDirection: "row",
    alignItems: "center",
    gap: getResponsiveSize(8),
    marginBottom: getResponsiveSize(12),
  },
  requirements: {
    marginLeft: getResponsiveSize(24),
    gap: getResponsiveSize(8),
  },
  requirementText: {
    fontSize: getResponsiveSize(14),
    color: FlickOColors.text.secondary,
    lineHeight: getResponsiveSize(20),
    fontFamily: "System", // Using system font like other text elements
  },
  uploadButton: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: FlickOColors.primary,
    padding: getResponsiveSize(12),
    borderRadius: 8,
    gap: getResponsiveSize(8),
    marginTop: getResponsiveSize(16),
  },
  uploadButtonText: {
    color: FlickOColors.white,
    fontSize: getResponsiveSize(14),
    fontWeight: "500",
  },
  costInput: {
    flexDirection: "row",
    alignItems: "center",
    gap: getResponsiveSize(8),
  },
  rupeeSymbol: {
    fontSize: getResponsiveSize(18),
    color: FlickOColors.text.primary,
  },
  imageExample: {
    borderRadius: 8,
    overflow: "hidden",
    marginBottom: getResponsiveSize(16),
  },
  exampleImage: {
    width: "100%",
    height: getResponsiveSize(200),
    resizeMode: "cover",
  },
  exampleText: {
    textAlign: "center",
    fontSize: getResponsiveSize(12),
    color: FlickOColors.text.secondary,
    marginTop: getResponsiveSize(8),
  },
  cuisinesGrid: {
    flexDirection: "row",
    flexWrap: "wrap",
    gap: width > 768 ? getResponsiveSize(12) : getResponsiveSize(8),
  },
  cuisineChip: {
    paddingHorizontal: getResponsiveSize(16),
    paddingVertical: getResponsiveSize(8),
    borderRadius: 20,
    borderWidth: 1,
    borderColor: FlickOColors.gray.light,
  },
  selectedCuisine: {
    backgroundColor: FlickOColors.primary,
    borderColor: FlickOColors.primary,
  },
  cuisineText: {
    color: FlickOColors.text.primary,
  },
  selectedCuisineText: {
    color: FlickOColors.white,
  },
  timingsContainer: {
    gap: getResponsiveSize(16),
  },
  timingRow: {
    flexDirection: width > 480 ? "row" : "column",
    alignItems: width > 480 ? "center" : "flex-start",
    gap: getResponsiveSize(8),
    marginBottom: getResponsiveSize(8),
  },
  dayControl: {
    flexDirection: "row",
    alignItems: "center",
    gap: getResponsiveSize(12),
  },
  timeInputs: {
    flexDirection: "row",
    alignItems: "center",
    gap: getResponsiveSize(12),
  },
  timeInput: {
    borderWidth: 1,
    borderColor: FlickOColors.gray.light,
    borderRadius: 8,
    padding: getResponsiveSize(8),
    width: getResponsiveSize(80),
  },
  editButton: {
    padding: getResponsiveSize(8),
  },
  editText: {
    color: FlickOColors.primary,
    fontSize: getResponsiveSize(14),
  },
  closedText: {
    color: FlickOColors.text.secondary,
  },
  stepTitle: {
    fontSize: getResponsiveSize(14),
    fontWeight: "500",
    marginBottom: getResponsiveSize(4),
  },
  activeText: {
    color: FlickOColors.primary,
  },
  divider: {
    height: 1,
    backgroundColor: FlickOColors.gray.light,
  },
  flex1: {
    flex: 1,
  },
  container: {
    flex: 1,
    backgroundColor: FlickOColors.gray.lighter,
  },
  wrapper: {
    padding: width > 768 ? getResponsiveSize(16) : getResponsiveSize(12),
    maxWidth: width > 1024 ? "80%" : 1200,
    alignSelf: "center",
    width: "100%",
  },
  content: {
    flexDirection: width > 768 ? "row" : "column",
    gap: getResponsiveSize(16),
    marginTop: getResponsiveSize(24),
  },
  sidebar: {
    width: width > 768 ? 320 : "100%",
    gap: width > 768 ? getResponsiveSize(16) : getResponsiveSize(12),
  },
  fullWidth: {
    width: "100%",
  },
  formContainer: {
    flex: 1,
    gap: width > 768 ? getResponsiveSize(16) : getResponsiveSize(12),
  },
  cardMargin: {
    marginTop: getResponsiveSize(15),
    marginHorizontal: getResponsiveSize(15),
  },
  card: {
    backgroundColor: FlickOColors.white,
    borderRadius: width > 768 ? 12 : 8,
    borderWidth: 1,
    borderColor: FlickOColors.gray.light,
    overflow: "visible",
    padding: width > 768 ? getResponsiveSize(16) : getResponsiveSize(12),
  },
  step: {
    padding: getResponsiveSize(16),
    flexDirection: "row",
    alignItems: "center",
  },
  activeStep: {
    backgroundColor: FlickOColors.primary + "10",
  },
  stepIcon: {
    fontSize: getResponsiveSize(20),
    marginRight: getResponsiveSize(12),
  },
  stepContent: {
    flex: 1,
  },
  section: {
    marginBottom: width > 768 ? getResponsiveSize(32) : getResponsiveSize(24),
  },
  sectionTitle: {
    fontSize: getResponsiveSize(16),
    fontWeight: "500",
    marginBottom: getResponsiveSize(4),
  },
  input: {
    boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)", // Add shadow here
    borderWidth: 1,
    borderColor: FlickOColors.gray.lighter,
    borderRadius: getResponsiveSize(8),
    padding: width > 768 ? getResponsiveSize(12) : getResponsiveSize(8),
    fontSize: width > 768 ? getResponsiveSize(16) : getResponsiveSize(14),
    color: FlickOColors.gray.dark,
    textAlignVertical: "center",
    height: width > 768 ? getResponsiveSize(48) : getResponsiveSize(40),
    lineHeight: width > 768 ? getResponsiveSize(24) : getResponsiveSize(20),
    minHeight: width > 768 ? getResponsiveSize(52) : getResponsiveSize(44),
    marginBottom: getResponsiveSize(16),
  },
  inputStLabel: {
    fontSize: width > 768 ? getResponsiveSize(12) : getResponsiveSize(11),
    color: FlickOColors.gray.medium, // Using a lighter shade for subtlety
    marginBottom: getResponsiveSize(4),
    marginLeft: getResponsiveSize(4),
    fontWeight: "500", // Semi-bold for better readability while staying subtle
  },
  phoneInput: {
    flexDirection: "row",
    alignItems: "center",
    gap: width > 480 ? getResponsiveSize(12) : getResponsiveSize(8),
    flexWrap: width > 480 ? "nowrap" : "wrap",
  },
  mapContainer: {
    height: getResponsiveSize(300),
    marginTop: getResponsiveSize(16),
  },
  searchBox: {
    flexDirection: "row",
    alignItems: "center",
    gap: getResponsiveSize(8),
    marginBottom: getResponsiveSize(16),
  },
  checkbox: {
    flexDirection: "row",
    alignItems: "center",
    gap: getResponsiveSize(8),
    marginTop: getResponsiveSize(12),
  },
  checkboxBox: {
    width: getResponsiveSize(20),
    height: getResponsiveSize(20),
    borderRadius: 4,
    borderWidth: 2,
    borderColor: FlickOColors.gray.light,
  },
  checkedBox: {
    backgroundColor: FlickOColors.primary,
    borderColor: FlickOColors.primary,
  },
  addressForm: {
    gap: getResponsiveSize(16),
  },
  note: {
    marginTop: getResponsiveSize(8),
    padding: getResponsiveSize(12),
    backgroundColor: FlickOColors.green,
    borderRadius: 8,
    color: FlickOColors.text.primary,
    fontSize: getResponsiveSize(14),
  },
  // New styles to add for ordercard:
  orderCard: {
    backgroundColor: FlickOColors.white,
    padding: getResponsiveSize(4),
    borderRadius: getResponsiveSize(8),
    marginBottom: getResponsiveSize(4),
    position: "relative",
    width: "100%", // Add width
  },

  orderHeader: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },

  orderId: {
    fontSize: getResponsiveSize(16),
    fontWeight: "600",
    color: FlickOColors.text.primary,
  },

  headerRight: {
    flexDirection: "row",
    alignItems: "center",
    gap: getResponsiveSize(12),
  },

  orderTime: {
    fontSize: getResponsiveSize(14),
    color: FlickOColors.text.secondary,
  },

  orderStatusRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    gap: getResponsiveSize(12),
    marginTop: getResponsiveSize(8),
  },

  statusChip: {
    paddingHorizontal: getResponsiveSize(8),
    paddingVertical: getResponsiveSize(4),
    borderRadius: getResponsiveSize(4),
    backgroundColor: FlickOColors.primary + "20",
  },
  delStatus: {
    backgroundColor: FlickOColors.success + "20",
  },

  statusText: {
    fontSize: getResponsiveSize(12),
    fontWeight: "600",
  },

  orderItems: {
    marginTop: getResponsiveSize(16),
    gap: getResponsiveSize(12),
  },

  itemRow: {
    flexDirection: "row",
    justifyContent: "space-between",
  },

  itemInfo: {
    flexDirection: "row",
    alignItems: "center",
    gap: getResponsiveSize(8),
  },

  itemText: {
    fontSize: getResponsiveSize(14),
    color: FlickOColors.text.primary,
  },
  borderButton: {
    borderBottomWidth: 1,
    borderBottomColor: FlickOColors.gray.light,
    marginTop: getResponsiveSize(16),
  },
  totalRow: {
    flexDirection: "row",
    alignItems: "center",
    paddingTop: getResponsiveSize(16),
  },

  totalText: {
    fontSize: getResponsiveSize(16),
    marginRight: getResponsiveSize(10),
    fontWeight: "600",
    color: FlickOColors.text.primary,
  },

  paymentChip: {
    paddingHorizontal: getResponsiveSize(8),
    paddingVertical: getResponsiveSize(4),
    borderRadius: getResponsiveSize(4),
  },

  paymentText: {
    fontSize: getResponsiveSize(12),
    fontWeight: "500",
  },

  deliveryInfo: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: getResponsiveSize(16),
    paddingTop: getResponsiveSize(16),
    borderTopWidth: 1,
    borderTopColor: FlickOColors.gray.light,
  },

  partnerInfo: {
    flexDirection: "row",
    alignItems: "center",
  },

  profilePic: {
    width: getResponsiveSize(40),
    height: getResponsiveSize(40),
    borderRadius: getResponsiveSize(20),
  },

  partnerDetails: {
    marginLeft: getResponsiveSize(12),
  },

  partnerName: {
    fontSize: getResponsiveSize(14),
    fontWeight: "500",
    color: FlickOColors.text.primary,
  },

  otpText: {
    fontSize: getResponsiveSize(12),
    color: FlickOColors.text.secondary,
    marginTop: getResponsiveSize(2),
  },

  callButton: {
    padding: getResponsiveSize(8),
    backgroundColor: FlickOColors.success + "10",
    borderRadius: getResponsiveSize(8),
  },
  dropdownContainer: {
    marginTop: getResponsiveSize(16),
    paddingTop: getResponsiveSize(16),
    borderTopWidth: 1,
    borderTopColor: FlickOColors.gray.light,
    position: "relative",
    zIndex: 1,
    width: "100%",
  },
  dropdownCont: {
    position: "relative",
    zIndex: 1,
    width: "100%",
  },
  dropdownButton: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    padding: getResponsiveSize(8),
    borderRadius: getResponsiveSize(8),
    backgroundColor: FlickOColors.blue,
    zIndex: 2,
  },

  dropdownButtonText: {
    fontSize: getResponsiveSize(14),
    color: FlickOColors.white,
    fontWeight: "600",
  },

  dropdownList: {
    backgroundColor: FlickOColors.white,
    borderRadius: getResponsiveSize(8),
    marginTop: getResponsiveSize(4),
    borderWidth: 1,
    borderColor: FlickOColors.gray.light,
  },

  partnerItem: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    padding: getResponsiveSize(12),
    borderBottomWidth: 1,
    borderBottomColor: FlickOColors.gray.light,
  },

  ordersCount: {
    fontSize: getResponsiveSize(12),
    color: FlickOColors.text.secondary,
  },
  actionButtons: {
    flexDirection: "row",
    gap: getResponsiveSize(8),
  },
  readyButton: {
    paddingHorizontal: getResponsiveSize(12),
    paddingVertical: getResponsiveSize(8),
    borderRadius: getResponsiveSize(6),
    marginLeft: getResponsiveSize(8),
  },
  readyButtonText: {
    fontWeight: "600",
    fontSize: getResponsiveSize(14),
  },
  overlay: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0,0,0,0.7)",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 9999,
  },
  popupContainer: {
    width: "90%",
    backgroundColor: FlickOColors.white,
    borderRadius: getResponsiveSize(12),
    padding: getResponsiveSize(16),
    elevation: 5,
  },
  newOrderTitle: {
    fontSize: getResponsiveSize(18),
    fontWeight: "600",
    color: FlickOColors.primary,
    textAlign: "center",
    marginBottom: getResponsiveSize(16),
  },
  actionButtons2: {
    flexDirection: "row",
    gap: getResponsiveSize(12),
    marginTop: getResponsiveSize(16),
  },
  actionButton2: {
    flex: 1,
    paddingVertical: getResponsiveSize(12),
    borderRadius: getResponsiveSize(8),
    alignItems: "center",
    justifyContent: "center",
  },
  rejectButton: {
    backgroundColor: FlickOColors.white,
    borderWidth: 1,
    borderColor: FlickOColors.gray.light,
  },
  acceptButton2: {
    backgroundColor: FlickOColors.success,
  },
  rejectButtonText: {
    color: FlickOColors.text.secondary,
    fontWeight: "600",
    fontSize: getResponsiveSize(14),
  },
  queueIndicator: {
    textAlign: "center",
    color: "#666",
    marginTop: 8,
    marginBottom: 8,
    fontSize: 14,
  },
  // Add to homeStyles.ts
  insightCard: {
    backgroundColor: FlickOColors.white,
    borderRadius: 12,
    padding: getResponsiveSize(16),
    marginBottom: getResponsiveSize(16),
  },
  seeMore: {
    flexDirection: "row",
    alignItems: "center",
    gap: getResponsiveSize(4),
  },
  seeMoreText: {
    color: FlickOColors.primary,
    fontSize: getResponsiveSize(14),
  },
  statsGrid: {
    flexDirection: "row",
    gap: getResponsiveSize(12),
    flexWrap: "wrap",
  },
  statBox: {
    flex: 1,
    minWidth: getResponsiveSize(150),
    padding: getResponsiveSize(12),
    backgroundColor: FlickOColors.gray.lightest,
    borderRadius: 8,
  },
  statTitle: {
    fontSize: getResponsiveSize(14),
    color: FlickOColors.text.secondary,
    marginBottom: getResponsiveSize(8),
  },
  statAmount: {
    fontSize: getResponsiveSize(20),
    fontWeight: "600",
    color: FlickOColors.text.primary,
    marginBottom: getResponsiveSize(4),
  },
  statOrders: {
    fontSize: getResponsiveSize(14),
    color: FlickOColors.text.secondary,
  },
  // Add to registrationStyles.ts
  helpContent: {
    padding: getResponsiveSize(16),
  },
  helpText: {
    fontSize: getResponsiveSize(16),
    color: FlickOColors.text.secondary,
    marginBottom: getResponsiveSize(24),
  },
  contactOptions: {
    gap: getResponsiveSize(16),
  },
  contactCard: {
    flexDirection: "row",
    alignItems: "center",
    padding: getResponsiveSize(16),
    backgroundColor: FlickOColors.white,
    borderRadius: 12,
    borderWidth: 1,
    borderColor: FlickOColors.gray.light,
    gap: getResponsiveSize(16),
  },
  contactInfo: {
    flex: 1,
  },
  contactTitle: {
    fontSize: getResponsiveSize(16),
    fontWeight: "500",
    color: FlickOColors.text.primary,
    marginBottom: getResponsiveSize(4),
  },
  contactDetail: {
    fontSize: getResponsiveSize(14),
    color: FlickOColors.text.secondary,
  },
  supportHours: {
    fontSize: getResponsiveSize(14),
    color: FlickOColors.text.secondary,
    textAlign: "center",
    marginTop: getResponsiveSize(24),
  },
  shiftText: {
    fontSize: getResponsiveSize(12),
    color: FlickOColors.gray.medium,
  },
  viewToggleButton: {
    paddingHorizontal: getResponsiveSize(12),
    paddingVertical: getResponsiveSize(6),
    marginHorizontal: getResponsiveSize(4),
    borderRadius: getResponsiveSize(4),
    borderWidth: getResponsiveSize(1),
    borderColor: FlickOColors.primary,
  },
  viewToggleButtonActive: {
    backgroundColor: FlickOColors.primary,
  },
  viewToggleText: {
    color: FlickOColors.primary,
    fontSize: getResponsiveSize(14),
  },
  viewToggleTextActive: {
    color: FlickOColors.white,
  },
});
